import { useState } from "react";

export function useHeaderDrawer() {
  const [drawerMode, setDrawerMode] = useState<"menu" | "locations" | null>(
    null,
  );

  const openMenuDrawer = () => setDrawerMode("menu");
  const openLocationDrawer = () => setDrawerMode("locations");
  const closeDrawer = () => setDrawerMode(null);

  return {
    isDrawerOpen: drawerMode !== null,
    drawerMode,
    openMenuDrawer,
    openLocationDrawer,
    closeDrawer,
  };
}
